// Shared site constants for Buzas landing page
export const SITE = {
  brand: "Buzas",
  tagline: "Soluções Industriais",
  whatsappNumber: "5511940272123", // digits only
  whatsappDisplay: "+55 (11) 94027-2123",
  phoneDisplay: "+55 (11) 94027-2123",
  email: "comercial@buzas.com.br",
  linkedin:
    "https://www.linkedin.com/company/buzas-industria-e-comercio-ltda/",
  instagram: "https://www.instagram.com/buzas_laser_service/",
  instagramHandle: "@buzas_laser_service",
  location: "São Paulo — SP, Brasil",
  legalName: "Buzas Indústria e Comércio Ltda",
  privacyPath: "/politica-de-privacidade",
  whatsappMessage: "Olá, quero falar com a Buzas",
  logos: {
    header:
      "https://customer-assets.emergentagent.com/job_buzas-engineering/artifacts/gvw5v3dr_%5BBuzas%5D_Logo_01.png",
    footer:
      "https://customer-assets.emergentagent.com/job_buzas-engineering/artifacts/997lqxm8_%5BBuzas%5D_Logo_02.png",
  },
  images: {
    heroMacro: "/images/hero-macro.png",
    factoryFloor: "/images/factory-floor.png",
    laserSparks:
      "https://images.unsplash.com/photo-1764114235896-034c8772de01?auto=format&fit=crop&w=1400&q=80",
    weldingDetail:
      "https://images.pexels.com/photos/2569842/pexels-photo-2569842.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
};

export const waLink = (msg = SITE.whatsappMessage) =>
  `https://api.whatsapp.com/send?phone=${SITE.whatsappNumber}&text=${encodeURIComponent(msg)}`;
